import { DynamicSection } from 'lib/types/filingType';
import { TextField } from 'lib/components/TextField';
import { GridInput } from 'lib/components/Card/Grid';
import { EditableCardProps } from 'lib/components/Card/EditableCardWrapper';

export default function DynamicSectionElement({
  value,
  onChange
}: EditableCardProps<DynamicSection>) {
  return (
    <>
      <GridInput>
        <TextField
          id={`section-name-${value.id}`}
          value={value.name}
          labelText="Section Name"
          onChange={newValue => {
            onChange({
              ...value,
              name: newValue,
              id: newValue.toLowerCase().replace(/\s+/g, '-')
            });
          }}
          placeholder="e.g., Header, Footer, Call to Action"
          required
        />
      </GridInput>
      <GridInput>
        <TextField
          id={`section-id-${value.id}`}
          value={value.id}
          disabled
          labelText="Section ID"
          onChange={newValue => {
            onChange({ ...value, id: newValue });
          }}
          required
          noteText="Unique identifier for this section (lowercase, no spaces)"
        />
      </GridInput>
      <GridInput fullWidth>
        <TextField
          id={`section-template-${value.id}`}
          value={value.template}
          labelText="Template"
          onChange={newValue => {
            onChange({ ...value, template: newValue });
          }}
          placeholder="String template with Handlebars syntax"
          noteText="Use Handlebars syntax for dynamic content, e.g., {{madlibData.questionTemplateData.firstName}}"
        />
      </GridInput>
      <GridInput>
        <TextField
          id={`section-text-style-${value.id}`}
          value={value.textStyle || ''}
          labelText="Text Style"
          onChange={newValue => {
            onChange({ ...value, textStyle: newValue || undefined });
          }}
          placeholder="ex. Heading 1"
          noteText="Name of InDesign paragraph style to apply to text content"
        />
      </GridInput>
      <GridInput>
        <TextField
          id={`section-object-style-${value.id}`}
          value={value.objectStyle || ''}
          labelText="Container Style"
          onChange={newValue => {
            onChange({ ...value, objectStyle: newValue || undefined });
          }}
          placeholder="ex. Callout Box"
          noteText="Name of InDesign object style to apply to the container element"
        />
      </GridInput>
    </>
  );
}
